<template>
  <div
    class="menuBg"
    :class="[hasBackgroundImage ? 'menuBg-hasBackgroundImage' : '']"
  >
    <div class="main-menu main-menu-Numpad">
      <order-header :is-payment="true" />
      <div class="headerWrapper">
        <div class="headerTitle">{{ $t(`numpad.header.title`) }}</div>
      </div>
      <div class="numpadContainer">
        <!--TODO themeable-->
        <div class="numpadImage"></div>
        <div class="numpadTitle" v-html="numpadTitle"></div>
        <div class="numpadEnteredNumber">
          <div>{{ number }}</div>
        </div>
        <div class="numpadButtons">
          <div class="rows">
            <div class="row">
              <button @click="addNumber">1</button>
              <button @click="addNumber">2</button>
              <button @click="addNumber">3</button>
            </div>
            <div class="row">
              <button @click="addNumber">4</button>
              <button @click="addNumber">5</button>
              <button @click="addNumber">6</button>
            </div>
            <div class="row">
              <button @click="addNumber">7</button>
              <button @click="addNumber">8</button>
              <button @click="addNumber">9</button>
            </div>
            <div class="row">
              <button @click="addNumber">0</button>
              <button @click="removeNumber" class="delete"></button>
            </div>
          </div>
        </div>
        <div class="numpadText" v-html="numpadText"></div>
      </div>

      <div class="actionBlock">
        <div class="closeBtn text" @click="back_to_cart">
          {{ $t(`numpad.btn.back`) }}
        </div>
        <button
          class="nextBtn background"
          @click="next"
          :disabled="!!nextDisabled"
        >
          {{ $t(`numpad.btn.next`) }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import OrderHeader from "@/components/order/OrderHeader.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { isBackgroundImageSet } from "@/utils/helpers";
import { isTableTentMode } from "@/utils/wbsIntegration";

export default {
  name: "Numpad",
  components: {
    OrderHeader
  },
  data() {
    return {
      number: ""
    };
  },
  computed: {
    ...mapGetters({
      delivery_method: "DELIVERY_METHOD_FULL",
      basket: "BASKET",
      site_setting: "SITE_SETTING",
      isManualMandatory: "IS_MANUAL_MANDATORY"
    }),
    isTableTentMode() {
      if (this.delivery_method && this.delivery_method.identifier) {
        return isTableTentMode(this.delivery_method.identifier);
      }
      return false;
    },
    nextDisabled() {
      if (this.isTableTentMode) {
        return !this.validateRange();
      } else {
        return this.isManualMandatory && !this.number;
      }
    },
    hasBackgroundImage() {
      return isBackgroundImageSet("--page_Numpad_menuBg_background-image");
    },
    numpadTitle() {
      // TODO setup tool config buzzer, puck, tablecard | ??? config site_setting ???
      if (this.isTableTentMode) {
        return this.$t("numpad.table_tent.title");
      } else {
        return this.$t("numpad.buzzer.title");
      }
    },
    numpadText() {
      // TODO setup tool config buzzer, puck, tablecard | ??? config site_setting ???
      if (this.isTableTentMode) {
        return this.$t("numpad.table_tent.text_mandatory");
      } else if (this.isManualMandatory) {
        return this.$t("numpad.buzzer.text_mandatory");
      } else {
        return this.$t("numpad.buzzer.text");
      }
    }
  },
  methods: {
    ...mapActions({ logRouter: "LOG_ROUTER" }),
    ...mapMutations({
      setManualPuck: "SET_MANUAL_PUCK"
    }),
    addNumber(event) {
      let lengthValidator = this.isTableTentMode
        ? this.checkLengthTableTent
        : this.checkLength;

      if (lengthValidator()) {
        this.number = this.number + event.target.innerText;
      }
    },
    validateRange() {
      if (!this.number) {
        return false;
      }
      // TODO read constants from setup tools
      let MIN_NUMBER = 1;
      let MAX_NUMBER = 20;
      let currentNumber = parseInt(this.number);
      if (typeof currentNumber !== "number") {
        return false;
      }
      return currentNumber >= MIN_NUMBER && currentNumber <= MAX_NUMBER;
    },
    checkLength() {
      // TODO read constants from setup tools
      let MAX_CHAR_COUNT = 3;
      return this.number.length < MAX_CHAR_COUNT;
    },
    checkLengthTableTent() {
      // TODO read constants from setup tools
      let MAX_CHAR_COUNT = 2;
      return this.number.length < MAX_CHAR_COUNT;
    },
    removeNumber() {
      if (this.number.length > 0) {
        this.number = this.number.substr(0, this.number.length - 1);
      }
    },
    pay() {
      this.logRouter({ name: "payment", router: this.$router });
    },
    back_to_cart() {
      if (this.basket.length !== 0) {
        this.logRouter({ name: "order", router: this.$router });
      } else {
        this.logRouter({ name: "home", router: this.$router });
      }
    },
    next() {
      console.log("next");
      if (this.isTableTentMode) {
        // add leading "0" for digits 0-9
        if (this.number.length == 1) {
          this.number = "0" + this.number;
        }
      }
      console.log("next setManualPuck this.number = " + this.number);
      this.setManualPuck(this.number);
      this.logRouter({ name: "checkout", router: this.$router });
    }
  }
};
</script>
<style lang="scss" scoped>
.main-menu-Numpad {
  justify-content: flex-start;
}

.menuBg {
  background: var(--page_Numpad_menuBg_background);
}

.menuBg-hasBackgroundImage {
  background-image: var(--page_Numpad_menuBg_background-image);
}

.actionBlock {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 60px;
  position: absolute;
  bottom: 80px;
}

.closeBtn {
  align-items: center;
  background-color: var(--page_Numpad_closeBtn_background-color);
  border: var(--page_Numpad_closeBtn_border);
  border-radius: var(--page_Numpad_closeBtn_border-radius);
  color: var(--page_Numpad_closeBtn_color);
  display: flex;
  font-family: var(--page_Numpad_closeBtn_font-family);
  font-size: var(--page_Numpad_closeBtn_font-size);
  height: 70px;
  justify-content: center;
  padding: var(--page_Numpad_closeBtn_padding);
  width: 210px;
}

.headerWrapper {
  position: absolute;
  top: 0;
  width: 1080px;
  text-align: center;
}

.headerTitle {
  color: var(--page_Numpad_headerTitle_color);
  font-family: var(--page_Numpad_headerTitle_font-family);
  font-size: var(--page_Numpad_headerTitle_font-size);
  text-transform: var(--page_Numpad_headerTitle_text-transform);
  transform: var(--page_Numpad_headerTitle_transform);
  line-height: var(--page_Numpad_headerTitle_line-height);
  padding: var(--page_Numpad_headerTitle_padding);
}

.nextBtn {
  align-items: center;
  background: var(--page_Numpad_nextBtn_background);
  border: var(--page_Numpad_nextBtn_border);
  border-radius: var(--page_Numpad_nextBtn_border-radius);
  color: var(--page_Numpad_nextBtn_color);
  display: flex;
  font-family: var(--page_Numpad_nextBtn_font-family);
  font-size: var(--page_Numpad_nextBtn_font-size);
  height: var(--page_Numpad_nextBtn_height);
  justify-content: center;
  outline: none;
  padding: var(--page_Numpad_nextBtn_padding);
  text-transform: var(--page_Numpad_nextBtn_text-transform);
  width: var(--page_Numpad_nextBtn_width);
}
.nextBtn:disabled {
  background: var(--page_Numpad_nextBtn_disabled_background);
}
.numpadContainer {
  position: absolute;
  top: 350px;
  width: 1080px;
  text-align: center;
}
.numpadImage {
  height: 180px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  background-image: var(--page_Numpad_numpadImage_background-image);
  background-repeat: no-repeat;
  background-position: center bottom;
}
.numpadTitle {
  color: var(--page_Numpad_numpadTitle_color);
  font-family: var(--page_Numpad_numpadTitle_font-family);
  font-size: var(--page_Numpad_numpadTitle_font-size);
  margin-bottom: 30px;
  text-transform: var(--page_Numpad_numpadTitle_text-transform);
}
.numpadText {
  color: var(--page_Numpad_numpadText_color);
  font-family: var(--page_Numpad_numpadText_font-family);
  font-size: var(--page_Numpad_numpadText_font-size);
  min-height: 300px;
}
.numpadEnteredNumber {
  color: var(--page_Numpad_numpadEnteredNumber_color);
  display: flex;
  font-family: var(--page_Numpad_numpadEnteredNumber_font-family);
  font-size: var(--page_Numpad_numpadEnteredNumber_font-size);
  height: 150px;
  justify-content: center;
  letter-spacing: var(--page_Numpad_numpadEnteredNumber_letter-spacing);
  margin-bottom: 40px;
  div {
    border-bottom: 2px solid #252525;
    min-width: 260px;
  }
}
.numpadButtons {
  display: flex;
  justify-content: center;
  margin-bottom: 140px;
  button {
    background-color: var(--page_Numpad_numpadButtons_background-color);
    border: var(--page_Numpad_numpadButtons_border);
    border-radius: var(--page_Numpad_numpadButtons_border-radius);
    color: var(--page_Numpad_numpadButtons_color);
    font-family: var(--page_Numpad_numpadButtons_font-family);
    font-size: var(--page_Numpad_numpadButtons_font-size);
    height: 118px;
    margin: 10px;
    padding: 0;
    width: 118px;
  }
  button:focus {
    outline: 0;
  }
  button.delete {
    background-image: var(--page_Numpad_numpadButtons_delete_background-image);
    background-repeat: no-repeat;
    background-position: var(
      --page_Numpad_numpadButtons_delete_background-position
    );
  }
  div.rows {
    width: 415px;
    div.row {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
